import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';
import { ReportSchedulingView } from '@futrli/views/ReportSchedulingView';
import { useApiView } from '@futrli/views/hooks/useApiView';

export const useReportSchedules = () => {
  const flags = useFlags();
  const isResourceSharingEnabled = !!flags.resourceSharing;
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const view = useApiView(
    useMemo(
      () => new ReportSchedulingView(workspaceId, organisationId, isConsolidation, {
        schedules: true,
        awaitingReview: true,
        exported: false,
        members: isResourceSharingEnabled
      }),
      [workspaceId, organisationId, isConsolidation, isResourceSharingEnabled]
    )
  );

  return {
    scheduleItems: view.state.isLoading ? [] : view.state.scheduleItems ?? [],
    scheduledReports: view.state.isLoading ? [] : view.state.scheduledReports,
    awaitingReviewReports: view.state.isLoading ? [] : view.state.awaitingReviewReports,
    isResourceSharingEnabled,
    isLoading: view.state.isLoading,
    errorLoading: view.state.errorLoading
  };
};
